import React from 'react';
import { Form, Icon, Input, Button } from 'antd';
import { withRouter } from "react-router-dom";
import DEMO from 'constants/demoData';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import authServices from '../../../../../services/authServices';
import { toast } from "react-toastify";
const FormItem = Form.Item;

class NormalForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      url: "",
      type: "password",
      confirmType: "password",
    }
    this.showHide = this.showHide.bind(this);
    this.confirmPassShowHide = this.confirmPassShowHide.bind(this);
  }

  componentDidMount() {
    const {
      match: {
        params: { setPassword },
      },
    } = this.props;
  }

  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === "password" ? "input" : "password",
    });
  }

  confirmPassShowHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      confirmType: this.state.confirmType === "password" ? "input" : "password",
    });
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const {
          match: {
            params: { code, setPassword },
          },
        } = this.props;
        this.setState({
          setPassword: setPassword,
        });
        const params = {
          code: code,
          password: values.password,
          confirmPassword: values.confirm,
        };

        authServices
          .setPassword(params)
          .then((response) => {
            if (response.status === 200) {
              toast.success("New Password Created Successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
              });
              // this.setState({ addModalShow: true });
              console.log('Received values of form: ', values);
              this.props.history.push(DEMO.home2);
            }
          })
          .catch((e) => {
            if (e.response.status === 400) {
              toast.error(e.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
              });
            }
          });

      }
    });
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }
  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  }
  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <section className="form-v1-container">
        <h2>Set Password?</h2>
        <p className="additional-info col-lg-10 mx-lg-auto mb-3">Thank For Verifying the Email!</p>

        <Form onSubmit={this.handleSubmit} className="form-v1">
          <FormItem


            hasFeedback
          >
            {getFieldDecorator('password', {
              rules: [{
                required: true, message: 'Please input your password!',
              },
                {
                  pattern:/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!#@+$%\-_=+<>])([a-zA-Z0-9!#+$@%\-_=+<>]+)$/,
                  message: `The password must contain at least 8 characters ( numbers,lower case and upper case letters, and at least one character: ! + % - < > @ _ #)`
               }
              , {
                validator: this.checkConfirm,
              }],
            })(
              <Input size="large" prefix={<span onClick={this.showHide} style={{ fontSize: 13 }}>
                {this.state.type === "password" ? (
                  <EyeInvisibleOutlined />
                ) : (
                  <EyeOutlined />
                )}
              </span>} type={this.state.type} placeholder="Password" />
            )}
          </FormItem>
          <FormItem
            hasFeedback
          >
            {getFieldDecorator('confirm', {
              rules: [{
                required: true, message: 'Please confirm your password!',
              }, {
                validator: this.checkPassword,
              }],
            })(
              <Input onBlur={this.handleConfirmBlur} size="large" prefix={<span style={{ fontSize: 13 }} onClick={this.confirmPassShowHide}>
                {this.state.confirmType === "password" ? (
                  <EyeInvisibleOutlined />
                ) : (
                  <EyeOutlined />
                )}
              </span>} type={this.state.confirmType} placeholder="Confirm Password" />
            )}
          </FormItem>

          <FormItem >
            <Button type="primary" htmlType="submit" className="btn-cta btn-block">Set Password</Button>
          </FormItem>
        </Form>

      </section>
    );
  }
}

const WrappedNormalForm = Form.create()(withRouter(NormalForm));


export default WrappedNormalForm;
